import mobile from 'is-mobile';

/** @description Return true if the screen width is smaller than 375px (potential mobile device)
 * @return {boolean} True if screen width is smaller than 375px
 */
export function isSmallScreen() {
    //return window.screen.width <= 420;
    return mobile();
}